(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const countrySelectors = document.querySelectorAll('.popout-list__option-country-selector');
    const touchStarts = new Map(); // Track touch start positions

    countrySelectors.forEach(selector => {
      selector.addEventListener('click', function () {
        const countryCode = this.getAttribute('data-country-code');
        const countryLanguage = this.getAttribute('data-country-language');
        const countryDomain = this.getAttribute('data-country-domain');
        const countryParams = this.getAttribute('data-country-params');

        // Store the selected country in localStorage
        localStorage.setItem('SELECTED_COUNTRY', countryCode);
        localStorage.setItem('SELECTED_LANGUAGE', countryLanguage.toLowerCase().slice(0, 2));
        localStorage.setItem('COUNTRY_CHECKED', 'true');

        // Close any open country selector popup
        const countrySelectorPopup = document.querySelector('country-selector');
        if (countrySelectorPopup) {
          countrySelectorPopup.classList.remove('show');
        }

        const targetUrl = buildTargetUrl({
          country: countryCode,
          language: countryLanguage.toLowerCase().slice(0, 2),
          domain: countryDomain,
          extraParams: countryParams
        });

        if (targetUrl) {
          window.location.assign(targetUrl);
        } else {
          updateLocalization({ country: countryCode, language: countryLanguage.toLowerCase().slice(0, 2) });
        }
      });
    });

    function handleClick(event) {
      const target = event.target.closest('.popout-list__option-country-selector');
      if (!target) return;

      // Check if this was a drag (for touch events)
      const touchStart = touchStarts.get(target);
      if (touchStart && event.changedTouches) {
        const touch = event.changedTouches[0];
        const distance = Math.abs(touch.clientX - touchStart.x) + Math.abs(touch.clientY - touchStart.y);
        if (distance > 10) {
          touchStarts.delete(target);
          return; // It was a drag, don't process
        }
      }

      touchStarts.delete(target);

      const countryCode = target.getAttribute('data-country-code');
      let countryLanguage = target.getAttribute('data-country-language');
      let countryDomain = target.getAttribute('data-country-domain');
      const countryParams = target.getAttribute('data-country-params');

      if (!countryCode) return;
      if (!countryLanguage) {
        countryLanguage = countryCode === 'DK' ? 'da' : 'en';
      }
      if (!countryDomain) {
        countryDomain = window.location.host;
      }

      localStorage.setItem('SELECTED_COUNTRY', countryCode);
      localStorage.setItem('SELECTED_LANGUAGE', countryLanguage.toLowerCase().slice(0, 2));
      localStorage.setItem('COUNTRY_CHECKED', 'true');

      const targetUrl = buildTargetUrl({
        country: countryCode,
        language: countryLanguage.toLowerCase().slice(0, 2),
        domain: countryDomain,
        extraParams: countryParams
      });

      if (targetUrl) {
        window.location.assign(targetUrl);
      } else {
        updateLocalization({ country: countryCode, language: countryLanguage.toLowerCase().slice(0, 2) });
      }
    }

    // Store touch start position
    document.addEventListener('touchstart', function(event) {
      const target = event.target.closest('.popout-list__option-country-selector');
      if (target && event.touches[0]) {
        touchStarts.set(target, { x: event.touches[0].clientX, y: event.touches[0].clientY });
      }
    }, { capture: true, passive: true });

    document.addEventListener('click', handleClick, true);
    document.addEventListener('mousedown', handleClick, true);
    document.addEventListener('touchend', handleClick, { capture: true, passive: false });
  });

  function normalizeCountryForUrl(code) {
    if (code === 'UK') return 'GB';
    if (code === 'EU') return 'DE';
    return code;
  }

  function buildTargetUrl({ country, language, domain, extraParams }) {
    try {
      const current = new URL(window.location.href);
      const protocol = current.protocol;
      const host = (domain || current.host)
        .replace(/^https?:\/\//, '')
        .replace(/\/$/, '')
        .replace(/\/.*/, '');

      let pathname = current.pathname || '/';
      if (pathname.startsWith('/da/')) {
        pathname = pathname.replace(/^\/da\//, '/');
      } else if (pathname === '/da') {
        pathname = '/';
      }

      const prefix = language === 'da' ? '/da' : '';
      const newPath = (prefix + pathname).replace(/\/+/, '/');

      const params = new URLSearchParams(current.search);
      params.set('country', normalizeCountryForUrl(country));

      if (extraParams) {
        const extra = new URLSearchParams(extraParams.replace(/^\?/, ''));
        extra.forEach((value, key) => {
          params.set(key, value);
        });
      }

      const query = params.toString();
      const hash = current.hash || '';
      const result = `${protocol}//${host}${newPath}${query ? `?${query}` : ''}${hash}`;
      return result;
    } catch (e) {
      console.error('Failed to build target URL', e);
      return null;
    }
  }

  function updateLocalization({ country, language }) {
    if (country === 'UK') {
      country = 'GB';
    }

    if (country === 'EU') {
      country = 'DE';
    }

    const formId = crypto.randomUUID();
    const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
    </form>
  `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
  }

  class CountrySelector extends HTMLElement {
    constructor() {
      super();
      console.log('CountrySelector initialized');
      this.LOCAL_STORAGE_KEY = 'COUNTRY_CHECKED';
      this.SELECTED_COUNTRY_KEY = 'SELECTED_COUNTRY';
      this.SELECTED_LANGUAGE_KEY = 'SELECTED_LANGUAGE';
      this.currentCountry = this.getAttribute('data-current-country');
      this.currentLanguage = this.getAttribute('data-current-language');
      if (this.currentCountry == "GB") {
        this.currentCountry = "UK";
      }

      if (this.currentCountry == "DE") {
        this.currentCountry = "EU";
      }

      console.log('Current country:', this.currentCountry);
      console.log('Current language:', this.currentLanguage);
      console.log('Current currency:', this.currentCurrency);

      // Check if user has a stored country preference and redirect if needed
      this.checkStoredCountryPreference();

      if (this.hasCountryBeenChecked()) {
        console.log('Country already checked, returning early');
        return;
      }

      const _this = this;

      const closeButton = this.querySelector('[data-popup-close]');
      if (closeButton) {
        console.log('Found close button');
        closeButton.addEventListener('click', () => {
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        });
      } else {
        console.log('Close button not found');
      }

      this.addEventListener('click', (event) => {
        if (!event.target.closest('.country-selector__content')) {
          console.log('Clicked outside content, closing');
          _this.removeCountrySelector();
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
        }
      });

      try {
        console.log('Fetching geolocation data');
        fetch(
          `https://rebuyengine.com/api/v1/customers/geolocation?key=06c0934b6d04add29935a8b78521d404b0df5cf5`
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            const geo = data;

            if (_this.shouldShowPopup(geo.data)) {
              console.log('Should show popup for country:', geo.data.country_code);
              setTimeout(() => {
                _this.showCountrySelector();
              }, 1000);
            } else {
              console.log('No need to show popup');
              localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
            }
          });
      } catch (err) {
        console.error('Error in Country Locator', err);
      }

      const links = [...this.querySelectorAll(".popout-list__option-country-selector")];
      this.countryCodes = links.map(link => link.dataset.countryCode);

      links.forEach((link) => {
        link.addEventListener("click", () => {
          localStorage.setItem(_this.LOCAL_STORAGE_KEY, 'true');
          _this.removeCountrySelector();
        });
      });
    }

    checkStoredCountryPreference() {
      const isDesignMode = document.documentElement.classList.contains('is-design-mode');
      if (isDesignMode) {
        console.log('Design mode detected. Not checking for stored country preference.');
        return;
      }

      const overrideCountryQuery = new URLSearchParams(window.location.search).get('country');

      if(overrideCountryQuery) {
        console.log('Override country query detected:', overrideCountryQuery);

        localStorage.setItem(this.LOCAL_STORAGE_KEY, 'true');
        localStorage.removeItem(this.SELECTED_COUNTRY_KEY);
        localStorage.removeItem(this.SELECTED_LANGUAGE_KEY);
        return;
      }

      const storedCountry = localStorage.getItem(this.SELECTED_COUNTRY_KEY);
      const storedLanguage = localStorage.getItem(this.SELECTED_LANGUAGE_KEY);

      console.log('Stored country:', storedCountry);
      console.log('Stored language:', storedLanguage);
      console.log('Current country:', this.currentCountry);
      
      if (storedCountry && storedCountry !== this.currentCountry) {
        console.log('Stored country preference detected:', storedCountry, 'current:', this.currentCountry);
        console.log('Redirecting to stored country preference');

        // Find matching link to obtain domain/params for stored country
        const links = [...this.querySelectorAll('.popout-list__option-country-selector')];
        const normalizedStored = normalizeCountryForUrl(storedCountry);
        const link = links.find(el => {
          const code = el.getAttribute('data-country-code');
          return code === storedCountry || normalizeCountryForUrl(code) === normalizedStored;
        });

        const domain = link ? link.getAttribute('data-country-domain') : null;
        const extraParams = link ? link.getAttribute('data-country-params') : null;

        const targetUrl = buildTargetUrl({
          country: storedCountry,
          language: (storedLanguage || 'en').toLowerCase().slice(0, 2),
          domain,
          extraParams
        });

        if (targetUrl) {
          window.location.replace(targetUrl);
        } else {
          updateLocalization({ 
            country: storedCountry, 
            language: storedLanguage || 'en' 
          });
        }
      }
    }

    shouldShowPopup(geo) {
      const detectedCountryCode = geo.country_code;
      const detectedContinentCode = geo.continent_code;

      console.log('Checking if should show popup for:', detectedCountryCode);
      console.log('Current country:', this.currentCountry);

      // Only show popup if detected country is not Denmark
      if ((detectedCountryCode === 'DK' || detectedCountryCode === 'Denmark') && this.currentCountry == "DK" ) {
        console.log('Should not show - Denmark detected');
        return false;
      }

      // Show popup if detected country is different from current country
      if (detectedCountryCode !== this.currentCountry) {
        console.log('Should show - different country detected');
        return true;
      }

      console.log('Should not show popup - same country');
      return false;
    }

    showCountrySelector() {
      if (this) {
        this.classList.add("show");
      }
    }

    removeCountrySelector() {
      console.log('Hiding country selector');
      if (this) {
        this.classList.remove("show");
      }
    }

    hasCountryBeenChecked() {
      const checked = typeof window !== 'undefined'
        ? localStorage.getItem(this.LOCAL_STORAGE_KEY)
        : true;

      console.log('Has country been checked:', checked);
      return checked;
    }
  }

  customElements.define("country-selector", CountrySelector)
})();